import { Link, useNavigate } from 'react-router-dom';
import styles from './OrderCard.module.scss';
import { Badge, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import {useToggle} from '../../../utils/hooks/useToggle';

export default function OrderCard({order}) {
    const navigate = useNavigate();

    const [showMore, setShowMore, toggleShowMore] = useToggle(false);
    
    const jsonDate = new Date(order.created_at);
    
    const dateTimeStamp = jsonDate.getTime();    
    
    const orderDate = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short',day: '2-digit', hour: '2-digit', minute: '2-digit', hour12:false}).format(dateTimeStamp);

    const handleFeedbackClick = () => {
        let feedbackUsername = order.is_sell ? order.user.username : order.seller.username;
        navigate(`/dashboard/add-feedback/?order=${order.id}&username=${feedbackUsername}`);
    }

  return (
    <>
        <Modal isOpen={showMore} toggle={toggleShowMore}>
            <ModalHeader toggle={toggleShowMore}>
                Description
            </ModalHeader>
            <ModalBody>
                {order.description}
            </ModalBody>
        </Modal>
        <div className={`${styles.orderItem} text-body d-grid p-2`} id={order.id}>
            <Link
                to={`/product/${order.product.id}`} 
                className={`text-decoration-none text-body ${styles.productImage} position-relative`}        
            >
                <img 
                    src={`${!order.product.image ? '/images.png' : `${process.env.REACT_APP_API_URL}${order.product.image}`}`}
                    className={`img-fluid ${styles.coverImage}`}
                    />
                    <Badge 
                        className={`position-absolute customBadge`} 
                        color={order.status == 'Complete' ? 'success' : 'danger'}
                    >
                        {order.status}
                    </Badge>
            </Link>
            <div className={`d-flex flex-column ms-2 ${styles.content}`}>
                <Link
                    to={`/product/${order.product.id}`}
                    className={`${styles.title} text-decoration-none text-body mb-2`}
                    >
                    {order.product.title}
                </Link>
                <div className='mb-2'>
                    <span className='fw-semibold'>
                        Price:{' '}
                    </span>
                    ${order.product.price}
                </div>
                <div className='mb-2'>
                    <span className='fw-semibold'>
                        Date:{' '}
                    </span>
                    {orderDate}
                </div>
                <div className='mb-2'>
                    <span className='fw-semibold'>
                        Order:{' '}#
                    </span>
                    <Link
                        to={`/product/${order.product.id}`}
                        className={`text-decoration-none`}>
                        {order.id}
                    </Link>
                </div>
                <div className={`mb-2 ${styles.description}`}>
                    {
                        order.is_sell == 1
                         ? <>
                            <span className='fw-semibold'>
                                Message:{' '}
                            </span>
                            {
                                
                                order.description 
                                    ? order.description.length < 20 
                                        ? order.description
                                        : <>
                                            <span>
                                                {order.description.substring(0,20)}...{' '}
                                            </span>
                                            <span 
                                                role='button'
                                                onClick={toggleShowMore}
                                                className='text-primary'>
                                                    Show More
                                            </span>
                                        </>
                                    : '-'
                                        
                            }
                           </>
                         : ''
                    }
                </div>

                <div className={`d-flex flex-row align-items-center`}>
                    <div className='flex-grow-1'>
                        {
                            order.is_sell == 1 
                                ? <span className='text-lighter-color' >Your product</span>
                                : <>
                                    <span className='fw-semibold'>Seller: </span>
                                    <Link
                                        to={`/vendor/${order.seller_id}`}
                                        className={`text-decoration-none text-tertiary`}
                                    >
                                        {order.seller.username}
                                    </Link>
                                  </>
                        }
                        
                    </div>
                    <div className={`justify-content-end ${styles.actions}`}>
                        <Button
                            onClick={handleFeedbackClick}
                            className='btn-sm'
                            disabled={order.has_feedback && true}
                        >
                            <i className='bi bi-emoji-smile me-2 text-tertiary'></i>
                            <span>
                                Feedback
                            </span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
